import { gsap } from 'gsap';

export default function () {
  let isPreloaderDone = false;

  document.addEventListener('preloaderDone', () => {
    isPreloaderDone = true;
  });

  function textAppears() {
    if (document.querySelector('[data-contact-form]')) {
      const blockContacts = document.querySelector('[data-contact-form]');
      const blockTop = blockContacts.querySelector('[data-contact-form-top]');
      const blockBottom = blockContacts.querySelector('[data-contact-form-bottom]');
      const blockFooter = blockContacts.querySelector('[data-contact-form-footer]');
      const blockMedia = blockContacts.querySelector('[data-contact-form-media]');

      if (blockTop) {
        gsap.set([blockTop, blockBottom, blockFooter], {
          opacity: 0,
          y: 80,
        });
        gsap.set(blockMedia, {
          opacity: 0,
          x: 80,
        });

        if (isPreloaderDone || sessionStorage.getItem('preloaderDone')) {
          gsap.to([blockTop, blockBottom, blockFooter], {
            y: 0,
            opacity: 1,
            duration: 1,
          });
          gsap.to(blockMedia, {
            x: 0,
            opacity: 1,
            duration: 1,
          });
        } else {
          document.addEventListener('preloaderDone', () => {
            gsap.to([blockTop, blockBottom, blockFooter], {
              y: 0,
              opacity: 1,
              duration: 1,
            });
            gsap.to(blockMedia, {
              x: 0,
              opacity: 1,
              duration: 1,
            });
          });
        }
      }
    }
  }

  textAppears();
}
